export default { sha: 'f9dcd3e93faf4b215ab927c12aab04a7ca2a60ab', buildNumber: 'undefined' }
